module.exports = __webpack_public_path__ + "media/mediaProfessionals/close_popup-dd62da49.png";